import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TokenStoreInjector } from '../utils/token-interceptor/token.interceptor';
import { TokenStoreService } from '../utils/token-interceptor/tokenstore.service';
import { VisitService } from './rest/visit.service';
import { ReportCoreService } from './rest/report-core.service';
import { ExaminationsFilter } from './report-workflow-exam.service';
import { WorklistService } from './rest/worklist.service';

@Injectable({
    providedIn: 'root',
})
export class SpecialtyReportingRestService extends VisitService {
    constructor(
        private reportCoreService: ReportCoreService,
        private worklistService: WorklistService,
        @Inject(TokenStoreInjector) tokenStore: TokenStoreService,
        httpClient: HttpClient,
    ) {
        super(tokenStore, httpClient);
    }

    retrieveAssociatedExaminations(idExaminations: string[]) {
        return this.worklistService.getCpRadioExaminationsByOpenReportMode({
            idExaminations,
        });
    }

    override searchExaminationsToAddToReport(options: ExaminationsFilter) {
        return this.reportCoreService.getExaminationsToAdd(options);
    }

    override searchExaminationsToRemoveFromReport(idReport: string) {
        return this.reportCoreService.getExaminationsToRemove(idReport);
    }
}
